import { finderRealOdd } from "../../components/functions/FunctionsCalculatorContent";
import { matrix } from "./matrix/matrix";
import { profit as CalcProfit } from "./profit/profit";
import { stakesCalculated } from "./stakesCalculated/stakesCalculated";
import { prizes as CalcProfitperBettingHouse } from "./prizes/prizes";
// # Ao Clicar no botão de fixar odd

// Moedas disponíveis para seleção em cada bookmaker (índice 0 = padrão).
export const CURRENCY_OPTIONS = ["BRL", "USD", "EUR"];

// Moeda de referência interna dos cálculos da calculadora.
const REFERENCE_CURRENCY = "BRL";



function getCurrencyRates(prongs, summarizeCurrencyId, exchangeRates, xxi_et=false) {
  return prongs.map(function (prong) {
    var prongCurrencyId = prong.currency.id;

    if (prongCurrencyId === summarizeCurrencyId) {
      // Mesma moeda: sem conversão.
      return 1;
    }


    // direction === "fromSum": sumarização -> prong
    return xxi_et ?  exchangeRates[prongCurrencyId][summarizeCurrencyId] : exchangeRates[summarizeCurrencyId][prongCurrencyId] ;
  });
}

// Taxas de conversão MOCKADAS (valores fictícios, apenas para desenvolvimento).
// NÃO são cotações reais de mercado. Centralizadas aqui para facilitar a
// substituição futura por dados vindos de uma API.
// Estrutura: MOCK_CURRENCY_RATES[moedaOrigem][moedaDestino] = taxa.
/*export const MOCK_CURRENCY_RATES = {
    EUR: { EUR: 1,    USD: 1.12, BRL: 5.60 },
    USD: { EUR: 0.89, USD: 1,    BRL: 5 },
    BRL: { EUR: 0.18, USD: 0.20, BRL: 1 }
};*/

// Retorna a taxa de conversão da moeda de origem para a moeda de destino.
// A conversão de uma moeda para ela mesma é sempre 1; combinações não
// cadastradas também retornam 1 (preserva o comportamento anterior).

function funcFromSumCurrencyRates(prongs /*, summarizeCurrencyId, exchangeRates*/, MOCK_CURRENCY_RATES) {
  //return getCurrencyRates(prongs, summarizeCurrencyId, exchangeRates, "fromSum");
  return getCurrencyRates(prongs, REFERENCE_CURRENCY, MOCK_CURRENCY_RATES);
}

function funcToSumCurrencyRates(prongs /*, summarizeCurrencyId, exchangeRates*/, MOCK_CURRENCY_RATES) {
  return getCurrencyRates(prongs, REFERENCE_CURRENCY, MOCK_CURRENCY_RATES, true);
}

export function calcSurebetWithSpecificFormula({
  formula,
  listOdds,
  allAdditionalInfoSurebet,
  qtMoneyPerBettingHouse,
  roundedValue,
  paramFixedValueId,
  paramSumStake,
  statusRounded,
  currencies = [],
  mockCurrencyRates,
}) {
  let realOddsBetHome = listOdds.map(function (__str, index_odd) {
    let realOdd = finderRealOdd(index_odd, listOdds, allAdditionalInfoSurebet);
    return realOdd;
  });

  let matriz = matrix(formula, realOddsBetHome);

  let profitsurebet = Number( ( ( CalcProfit(matriz) ) * 100  ).toFixed(2) );
  let qtOdds = listOdds.length;
  let distributions = new Array(qtOdds).fill(true);
  let rate001 = new Array(qtOdds).fill(1);
  let listStake = qtMoneyPerBettingHouse;
  //let fromSumCurrencyRates = listOdds.map(
  //  (__str, index) =>
  //    getCurrencyRate(currencies[index] ?? "BRL", REFERENCE_CURRENCY),
  //);
  

  
  
  let fr1111omSumCurrencyRates = currencies.map((item) => {return {currency: { id: item}}} )
  .filter( (item) => item.currency.id != undefined
  )

  
  let rates = funcFromSumCurrencyRates(fr1111omSumCurrencyRates, mockCurrencyRates)
  

  let cashInit = funcToSumCurrencyRates(fr1111omSumCurrencyRates, mockCurrencyRates);

  let newlistStakes = cashInit.map((item, index) => listStake[index] * item);
  

  let listRoundedValues = new Array(qtOdds).fill(roundedValue);

  let stakesPerBettingHouse = stakesCalculated({
    matrix: matriz,
    distributions: distributions,
    fixedValueId: paramFixedValueId,
    sumStake: paramSumStake,
    stakes: newlistStakes,
    fromSumCurrencyRates: rate001,
    isRoundStakes: statusRounded, // Arredondamento esta ativo?
    isRoundExchangeRates: false,
    roundToValues: listRoundedValues, // Lista de valores arredondado
    roundStakesTo: roundedValue, // valor do arredondamento
  }).map((item, index) => Number( item.toFixed(2) ));

  let profitperBettingHouse = CalcProfitperBettingHouse(
    matriz,
    stakesPerBettingHouse,
  ).map((item) => Number(item.toFixed(2)));
  let budgetSurebet = Number((stakesPerBettingHouse.reduce(
    (accumulator, currentValue) => {
      return accumulator + currentValue;
    },
    0,
  )).toFixed(2));

  
  return {
    "stakes": stakesPerBettingHouse.map((item, index) => (item * rates[index])),
    "profitperBettingHouse": profitperBettingHouse,
    "profit": profitsurebet,
    "budget": budgetSurebet,
  };
}

export function calcNoFixedStake({
  formula,
  listOdds,
  allAdditionalInfoSurebet,
  stakesPerBettingHouse,
  currencies,
  mockCurrencyRates,
}) {

  let realOddsBetHome = listOdds.map(function (__str, index_odd) {
    let realOdd = finderRealOdd(index_odd, listOdds, allAdditionalInfoSurebet);
    return realOdd;
  });
  let matriz = matrix(formula, realOddsBetHome);


  let fr1111omSumCurrencyRates = currencies.map((item) => {return {currency: { id: item}}} )
  .filter( (item) => item.currency.id != undefined
  )

  
  let rates = funcFromSumCurrencyRates(fr1111omSumCurrencyRates, mockCurrencyRates)

  let cashInit = funcToSumCurrencyRates(fr1111omSumCurrencyRates, mockCurrencyRates);

  let newlistStakes = cashInit.map((item, index) => stakesPerBettingHouse[index] * item);


  let profitperBettingHouse = CalcProfitperBettingHouse(matriz, newlistStakes).map(
    (item) => Number(item.toFixed(2)),
  );
  let budgetSurebet = Number((newlistStakes.reduce(
    (accumulator, currentValue) => {
      return accumulator + currentValue;
    },
    0,
  )).toFixed(2));


  return {
    "stakes": newlistStakes.map((item, index) => (item * rates[index])),
    "profitperBettingHouse": profitperBettingHouse,
    "budget": budgetSurebet,
  };
}
